import { Injectable } from '@angular/core';
import { IManufacturer, MobileInventoryCountService } from '@ups/tool-tracker';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchManufacturerService {
  constructor(public inventoryCountService: MobileInventoryCountService) {}

  search(searchString: string) {
    const filtered = this.inventoryCountService.manufacturerList.filter(
      (item: IManufacturer) => {
        return (
          item.manufacturerName
            ?.toLowerCase()
            .indexOf(searchString.toLowerCase()) > -1
        );
      }
    );

    return of(filtered);
  }
}
